import { TextField } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';

import { TargetAttributeDto, TargetAttributeDtoType } from '@/generated/model';
import RemoteListEditor from './RemoteListEditor';
import VehicleTypeEditor from './VehicleTypeEditor';

export default function TypeBasedEditor({ params }: { params: GridRenderEditCellParams }) {
  const { id, field, row, value, api } = params;
  const targetAttribute: TargetAttributeDto = row;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    void api.setEditCellValue({ id, field, value: event.target.value });
  };

  const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = event.target.value;
    const parsed = value === null ? null : Number(value);
    void api.setEditCellValue({ id, field, value: parsed });
  };

  switch (targetAttribute.type) {
    case TargetAttributeDtoType['@string']:
      return <TextField className="target-attribute-value" value={value} onChange={handleChange} autoFocus />;
    case TargetAttributeDtoType['@int']:
    case TargetAttributeDtoType['@long']:
      return (
        <TextField
          className="target-attribute-value"
          type="number"
          value={value}
          onChange={handleNumberChange}
          autoFocus
        />
      );
    case TargetAttributeDtoType['@list']:
      return <RemoteListEditor params={params} />;
    case TargetAttributeDtoType['@class']:
      return <VehicleTypeEditor params={params} />;
    default:
      return <TextField className="target-attribute-value" disabled value={value || ''} />;
  }
}
